import styled from 'styled-components'

export const MessageWrapper = styled.div`
  display: flex;
  text-align: left;
  align-items: center;
  margin-bottom: 15px;

  p {
    margin: 0 0 0 20px;
    color: #b72133;
    font-weight: bold;
  }
`

export const CodigoPixWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 30px 30px 0px 30px;
  margin-top: 10px;
  background: rgb(254, 248, 250);
`

export const IconWrapper = styled.div`
  margin-left: 3px;
  svg {
    path {
      stroke: #b72133;
    }
  }
`
